if (!customElements.get('faq-panel')) {
  customElements.define(
    'faq-panel',
    class faqPanel extends HTMLElement {
      constructor() {
        super();

        this.filterPanel = this.querySelector('.filter-panel');

        if (this.filterPanel) {
          this.searchInput = this.filterPanel.querySelector('input[type="search"]');
        }
        this.tabsBtns = this.filterPanel.querySelectorAll('.button');

        this.tabs = this.querySelectorAll('.faq-list');
        this.empty = this.querySelector('.empty-faq-list');

        this._activeTab = this.tabs[0];

        this.tabsBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.activeTab = btn.dataset.target;
          });
        });

        this.searchInput.addEventListener('input', () => {
          this.filterList();
        });

        const node = document.querySelector('.top-section');
        const offset = node.clientHeight - 60;

        window.addEventListener('scroll', () => {
          if (window.pageYOffset <= offset || document.documentElement.scrollTop <= offset)
            this.filterPanel.classList.remove('filter-fixed');
          else {
            this.filterPanel.classList.add('filter-fixed');
            this.filterPanel.style.top = `${this.fixedTopDistance}px`;
          }
        });
      }

      set activeTab(target) {
        this.tabs.forEach((tab) => {
          if (tab.id == target) this._activeTab = tab;
          else tab.classList.add('hidden');
        });

        this.tabsBtns.forEach((btn) => {
          if (btn.dataset.target == target) {
            btn.classList.remove('button-transparent');
          } else btn.classList.add('button-transparent');
        });

        this.filterList();
      }

      get activeTab() {
        return this._activeTab;
      }

      get list() {
        return this.activeTab.querySelectorAll('.faq-item');
      }

      get hiddenItems() {
        return this.activeTab.querySelectorAll('.faq-item.hidden');
      }

      get fixedTopDistance() {
        return document.querySelector('.app-banner') ? 130 : 130;
      }

      filterList() {
        this.empty.classList.add('hidden');
        this.activeTab.classList.add('hidden');

        const query = this.searchInput.value.toLowerCase().trim();

        this.list.forEach((item) => {
          const questionElement = item.querySelector('.question');
          const answerElement = item.querySelector('p');

          let question = '';
          if (questionElement) {
            question = questionElement.textContent.toLowerCase();
          }

          let answer = '';
          if (answerElement) {
            answer = answerElement.textContent.toLowerCase();
          }

          if (question.includes(query) || answer.includes(query)) item.classList.remove('hidden');
          else item.classList.add('hidden');
        });

        if (this.hiddenItems.length == this.list.length) this.empty.classList.remove('hidden');
        else this.activeTab.classList.remove('hidden');
      }
    },
  );
}
